import React from 'react';
import { Box } from '@mui/system';
import './style';
import { StyledPlaySimpleMainProduct } from './style';

type MainProductProps = {
  productImage?: string;
  textColor?: string;
  quantityDisplay?: string;
  strokedSaleQuantity?: string;
  salePercentage?: number;
};

export const MainProduct: React.FC<MainProductProps> = ({
  productImage = '',
  textColor = '#FFF',
  quantityDisplay = '100',
  strokedSaleQuantity = '100',
  salePercentage = 0,
}) => {
  return (
    <StyledPlaySimpleMainProduct>
      <Box className="main-product--image">
        {productImage && (
          <img src={productImage} alt="main-product" className="image" />
        )}
      </Box>
      <Box className="main-product--amount">
        <span
          className="main-product--amount__price"
          style={{
            color: textColor,
          }}
        >
          {quantityDisplay}
        </span>
        {salePercentage > 0 && (
          <p className="main-product--amount__stroked">{strokedSaleQuantity}</p>
        )}
      </Box>
    </StyledPlaySimpleMainProduct>
  );
};
